import axios from "axios";
import at from "lodash/at";
import { requestArtistTracks, recieveArtistTracks } from "./reducers/artistTracks";
import { requestArtistDetails, recieveArtistDetails } from "./reducers/artistDetails";
import { setError } from "./reducers/error";
import { TrackTitle } from "./components/TrackTable/customCells";

export default {
    BeatStars: {
        fetchArtistTracks(json) {
            return (dispatch) => {
                const [numTracks, artistId] = at(
                    json,
                    `response.data.user_contents.tracks`,
                    `response.data.profile.user_id`
                );

                dispatch(requestArtistTracks());

                return axios
                    .get(
                        `${process.env.REACT_APP_BEATSTARS_BASE_URL}/tracks?list_type=musician_playlist&track_fields=details,licenses,stats&track_type=all&list_limit=${numTracks}&musician_id=${artistId}`
                    )
                    .then((response) => {
                        const normalizedData = response.data.response.data.list.map((track) => {
                            return {
                                title: track.details.title,
                                stream_url: track.details.stream_url,
                                bpm: track.details.bpm,
                                duration: track.details.duration,
                                share: track.details.share_uri,
                                price: track.licenses.min_price,
                                likes: track.stats.likes,
                                plays: track.stats.plays
                            };
                        });
                        dispatch(recieveArtistTracks(normalizedData));
                    })
                    .catch((e) => {
                        dispatch(recieveArtistTracks([]));
                        dispatch(
                            setError(JSON.stringify(e.response.data.response, null, 2) || e.message)
                        );
                    });
            };
        },
        fetchArtistDetails(artistName) {
            return (dispatch) => {
                dispatch(requestArtistDetails(artistName));
                return axios
                    .get(
                        `${process.env.REACT_APP_BEATSTARS_BASE_URL}/musician?permalink=${artistName}&fields=profile,user_contents,stats`
                    )
                    .then((response) => dispatch(recieveArtistDetails(response.data)))
                    .catch((e) => {
                        dispatch(recieveArtistDetails(null));
                        dispatch(
                            setError(JSON.stringify(e.response.data.response, null, 2) || e.message)
                        );
                    });
            };
        },
        searchFilters: [
            {
                name: "Plays",
                key: "plays",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "Likes",
                key: "likes",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "BPM",
                key: "bpm",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "Price",
                key: "price",
                condition: "SELECT",
                index: 0,
                size: 0
            }
        ],
        tableConfig: [
            {
                Header: "Filename",
                accessor: "title",
                Cell: TrackTitle
            },
            {
                Header: "Length",
                accessor: "duration",
                disableFilters: true
            },
            {
                Header: "Plays",
                accessor: "plays",
                disableFilters: true
            },
            {
                Header: "Likes",
                accessor: "likes",
                disableFilters: true
            },
            {
                Header: "BPM",
                accessor: "bpm",
                disableFilters: true
            },
            {
                Header: "Price",
                accessor: "price",
                disableFilters: true
            }
        ]
    },
    TrakTrain: {
        fetchArtistTracks(html) {
            return (dispatch, getState) => {
                const selectedScraper = getState().selectedScraper.value;
                dispatch(requestArtistTracks(selectedScraper));

                const parser = new DOMParser();
                const parsedArtistPage = parser.parseFromString(html, "text/html");

                const trackArray = Array.from(
                    parsedArtistPage.querySelectorAll(".js-player-mark-active")
                );

                const normalizedData = trackArray.reduce((tracks, currentTrack) => {
                    if (currentTrack.classList.contains("beat-list--featured")) {
                        return tracks;
                    }

                    const trackData = JSON.parse(
                        currentTrack.querySelector(".beat-list__image > .overlay > .overlay__play")
                            .dataset.playerInfo
                    );

                    tracks.push({
                        title: trackData.name,
                        stream_url: `${process.env.REACT_APP_TRAKTRAIN_API_URL}${trackData.src}`,
                        share: `${process.env.REACT_APP_TRAKTRAIN_BASE_URL}${trackData.producerLink}`,
                        bpm: trackData.bpm,
                        price: trackData.prices[0][1]
                    });

                    return tracks;
                }, []);

                dispatch(recieveArtistTracks(normalizedData, selectedScraper));
            };
        },
        fetchArtistDetails(artistName) {
            return (dispatch) => {
                dispatch(requestArtistDetails(artistName));
                return axios
                    .get(
                        `${process.env.REACT_APP_CORS_PROXY_URL}/${process.env.REACT_APP_TRAKTRAIN_BASE_URL}/${artistName}`
                    )
                    .then((response) => dispatch(recieveArtistDetails(response.data)))
                    .catch((e) => {
                        dispatch(recieveArtistTracks([]));
                        dispatch(
                            setError(JSON.stringify(e.response.data.response, null, 2) || e.message)
                        );
                    });
            };
        },
        searchFilters: [
            {
                name: "BPM",
                key: "bpm",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "Price",
                key: "price",
                condition: "SELECT",
                index: 0,
                size: 0
            }
        ],
        tableConfig: [
            {
                Header: "Filename",
                accessor: "title",
                Cell: TrackTitle
            },
            {
                Header: "BPM",
                accessor: "bpm",
                disableFilters: true
            },
            {
                Header: "Price",
                accessor: "price",
                disableFilters: true
            }
        ]
    },
    Airbit: {
        fetchArtistTracks(json) {
            return (dispatch) => {
                const [artistId, artistName] = at(json, `item.id`, `item.username`);

                dispatch(requestArtistTracks());

                // Todo: Need an initial call in here to get number of beats to download

                return axios
                    .get(`${process.env.REACT_APP_AIRBIT_BASE_URL}/users/${artistId}/beats`)
                    .then((response) => {
                        const normalizedData = response.data.items.map((track) => {
                            return {
                                title: track.name,
                                stream_url: track.http,
                                bpm: track.tempo,
                                duration: track.duration,
                                share: `https://airbit.com/${artistName}/${track.alias}`,
                                price: track.pricing[0].price,
                                likes: track.likes,
                                plays: track.plays
                            };
                        });
                        dispatch(recieveArtistTracks(normalizedData));
                    })
                    .catch((e) => {
                        dispatch(recieveArtistTracks([]));
                        dispatch(setError(JSON.stringify(e.response.data, null, 2) || e.message));
                    });
            };
        },
        fetchArtistDetails(artistName) {
            return (dispatch) => {
                dispatch(requestArtistDetails(artistName));
                return axios
                    .get(
                        `${process.env.REACT_APP_AIRBIT_BASE_URL}/users/${artistName}?expand=profile&marketplace=1`
                    )
                    .then((response) => dispatch(recieveArtistDetails(response.data)))
                    .catch((e) => {
                        dispatch(recieveArtistDetails(null));
                        dispatch(setError(JSON.stringify(e.response.data, null, 2) || e.message));
                    });
            };
        },
        searchFilters: [
            {
                name: "Plays",
                key: "plays",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "Likes",
                key: "likes",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "BPM",
                key: "bpm",
                condition: "SELECT",
                index: 0,
                size: 0
            },
            {
                name: "Price",
                key: "price",
                condition: "SELECT",
                index: 0,
                size: 0
            }
        ],
        tableConfig: [
            {
                Header: "Filename",
                accessor: "title",
                Cell: TrackTitle
            },
            {
                Header: "Length",
                accessor: "duration",
                disableFilters: true
            },
            {
                Header: "Plays",
                accessor: "plays",
                disableFilters: true
            },
            {
                Header: "Likes",
                accessor: "likes",
                disableFilters: true
            },
            {
                Header: "BPM",
                accessor: "bpm",
                disableFilters: true
            },
            {
                Header: "Price",
                accessor: "price",
                disableFilters: true
            }
        ]
    }
};
